import React, { useState, useEffect } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CircularProgress from "@mui/material/CircularProgress";
import Slider from "@mui/material/Slider";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useToken } from "../items/UseToken";
import { Box, Grid, Typography, Paper } from "@mui/material";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import SimCardIcon from "@mui/icons-material/SimCard";
import CallIcon from "@mui/icons-material/Call";
import { useUser } from '../../Hooks/UserContext';
import NumberSelection from './TelephonyWizardComponents/NumberSelection';


const steps = [
    "Choose mode",
    "Configure",
    "Test Connection"
];

const options = [
    {
        key: "buy",
        title: "Get One",
        description: "Get a new number",
        icon: <PhoneIphoneIcon fontSize="large" />,
    },
    {
        key: "bring",
        title: "Bring Your Own",
        description: "Use your existing number",
        icon: <SimCardIcon fontSize="large" />,
    },
];

export default function TelephonyWizardStepper(props) {
    const { token } = useToken();
    const { user } = useUser();
    const [activeStep, setActiveStep] = useState(0);
    const [number, setNumber] = useState(null);
    const [vendor, setVendor] = useState("twilio");
    const [selectedOption, setSelectedOption] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null); // Error handling


    const modes = ["selfhosted", "cloud"];
    useEffect(() => {
        
    }, [token]);

    // Step: Fetch AI-generated face image

    // Fetch machines from API where agent_id is empty (null)

    const handleSelect = (key) => {
        setSelectedOption(key);
    };

    const handleRegister = () => {
        setLoading(true);
        const requestOptions = {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token,
            },
            body: JSON.stringify({
                number: number,
                vendor: vendor,
                registered_by: user.username,
                agent_id: "UNASSIGNED"
            }),
        };

        fetch('api/createtelephony', requestOptions)
            .then((response) => {
                if (!response.ok) {
                    // If response is not ok, throw an error to trigger catch block
                    throw new Error(`Failed to create telephone: ${response.status} ${response.statusText}`);
                }
                return response.text(); // Parse the response (optional)
            })
            .then((data) => {
                setLoading(false);
                setActiveStep((prevStep) => prevStep + 1)
            })
            .catch((error) => {
                console.error("Error creating telephone:", error);
                alert("Failed to create. Please try again."); // User feedback
            });
    };
    const handleDone = () => {


        props.handleDialogClose()
    }
    

    const handleNext = () => {
        setActiveStep((prevStep) => prevStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevStep) => prevStep - 1);
    };

    return (
        <Box sx={{ width: "100%", padding: "2rem" }}>
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            {/* Step Content */}
            <Box sx={{ mt: 4 }}>

                {activeStep === 0 && (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: 2,
                        }}
                    >
                        <Typography variant="h5" sx={{ marginBottom: 3 }}>
                            Select Your Option
                        </Typography>
                        <Grid container spacing={4} justifyContent="center" sx={{ maxWidth: 900 }}>
                            {options.map((option) => (
                                <Grid item key={option.key}>
                                    <Paper className="card-shine"
                                        onClick={() => handleSelect(option.key)}
                                        elevation={0}
                                        sx={{
                                            width: 280,
                                            height: 200,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            textAlign: "center",
                                            borderRadius: 4,
                                            cursor: "pointer",
                                            backgroundColor: selectedOption === option.key ? "#f9fafb" : "#ffffff",
                                            border: selectedOption === option.key
                                                ? "2px solid #6366f1"
                                                : "1px solid #e5e7eb",
                                            boxShadow: selectedOption === option.key
                                                ? "0 4px 16px rgba(99,102,241,0.15)"
                                                : "0 4px 14px rgba(0,0,0,0.04)",
                                            transition: "all 0.25s ease",
                                            transform: selectedOption === option.key ? "translateY(-3px)" : "none",
                                            "&:hover": {
                                                border: "2px solid #7F56D9",
                                                boxShadow: "0 6px 18px rgba(99,102,241,0.2)",
                                                transform: "translateY(-4px)",
                                                backgroundColor: "#fafafa",
                                            },
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: 72,
                                                height: 72,
                                                borderRadius: "20%",
                                                backgroundColor: "#f4f4f5",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                mb: 2,
                                                transition: "background-color 0.3s",
                                                "& svg": {
                                                    fontSize: 38,
                                                    color: selectedOption === option.key ? "#6366f1" : "#64748b",
                                                },
                                            }}
                                        >
                                            {option.icon}
                                        </Box>

                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontWeight: 600,
                                                letterSpacing: 0.4,
                                                mb: 0.8,
                                                color: selectedOption === option.key ? "#111827" : "#1f2937",
                                            }}
                                        >
                                            {option.title}
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            sx={{
                                                opacity: 0.8,
                                                maxWidth: 200,
                                                color: "#4b5563",
                                                fontSize: "0.9rem",
                                                lineHeight: 1.4,
                                            }}
                                        >
                                            {option.description}
                                        </Typography>
                                    </Paper>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                       
                )}
                {activeStep === 1 && (
                    selectedOption === "buy" ?
                        <NumberSelection handleNext={handleNext} setNumber={setNumber}></NumberSelection>
                    :
                    <Box textAlign="center">
                        <Typography variant="h6">Enter Telephone Number</Typography>
                        <Box sx={{ display: "inline-grid",  mt: 4 }}>
                                <TextField
                                    label="Number"
                                    variant="outlined"
                                    value={number}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        // Remove invalid characters and allow only one '+' at the start
                                        const sanitizedInput = input.replace(/(?!^\+)[^0-9]/g, ""); // Allow '+' only at the beginning and digits elsewhere
                                        if (sanitizedInput === "" || sanitizedInput.startsWith("+")) {
                                            setNumber(sanitizedInput);
                                        }
                                    }}
                                    error={!number || !/^\+\d+$/.test(number)} // Validate that it starts with '+' and contains digits
                                    helperText={
                                        !number || !/^\+\d+$/.test(number)
                                            ? "Must start with '+' and contain only digits"
                                            : ""
                                    }
                                    sx={{ mb: 2 }}
                                />


                        </Box>
                        {loading && <Box sx={{ margin: "10vw", display: "block", mt: 4 }}><CircularProgress sx={{ mt: 10 }} /></Box>}
                    </Box>
                )}

                {activeStep === 2 && (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: 2,
                        }}
                    >
                        <Paper
                            elevation={3}
                            sx={{
                                padding: 4,
                                maxWidth: 400,
                                textAlign: "center",
                                borderRadius: 3,
                                backgroundColor: "white",
                            }}
                        >
                            <CallIcon
                                fontSize="large"
                                sx={{ color: "#1976d2", marginBottom: 2 }}
                            />
                            <Typography variant="h5" sx={{ marginBottom: 1 }}>
                                Call to Test
                            </Typography>
                            <Typography variant="body1" sx={{ marginBottom: 3 }}>
                                To test your connection, please call the following number:
                            </Typography>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: "bold",
                                    color: "#1976d2",
                                    marginBottom: 2,
                                }}
                            >
                                {number}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                Ensure you can communicate with a test agent.
                            </Typography>
                        </Paper>
                    </Box>
                )}



                {/* Navigation Buttons */}
                <Box sx={{ display: "flex", justifyContent: "space-around", mt: 4 }}>
                    {3 > activeStep > 1 &&(
                        <Button onClick={handleBack} variant="outlined">
                            Back
                        </Button>
                    )}
                    
                    {activeStep < steps.length - 1 ? (
                        <Button onClick={activeStep !== steps.length - 2 ? handleNext : handleRegister} variant="contained" hidden={
                            (activeStep === 0 && !selectedOption)
                            ||
                            (activeStep === 1 && !number  )
                            ||
                            (activeStep === 1 && selectedOption === "buy")
                        }>
                            Next
                        </Button>
                    ) :
                        (
                            <Button onClick={handleDone} variant="contained" color="success">
                            Done
                        </Button>
                    )}
                </Box>
            </Box>
        </Box>
    );
}
